{
  "nl": {
    "courseDetail": {
      "headers": {
        "title": "Cursusdetails"
      },
      "labels": {
        "course": "Online-Nascholing",
        "webinar": "Live-Webinar",
        "impulse": "fobizz Impuls",
        "workshop": "Workshop"
      },
      "headings": {
        "learningGoals": "Leerdoelen",
        "lessons": "Inhoud",
        "recommendations": "Deze onderwerpen kunnen je ook interesseren",
        "feedbacks": "Beoordelingen"
      },
      "buttons": {
        "startNextLesson": "Start de volgende eenheid",
        "startImpulse": "Start de Impuls",
        "enrollFree": "Nu inschrijven",
        "enrollFreeGroup": "Nu inschrijven",
        "enrollFreeSubscription": "Nu inschrijven",
        "enrollSubscription": "Flatrate afsluiten",
        "enrollInternationalSubscription": "fobizz Licentie",
        "orderFreeFlatrate": "Flatrate testen",
        "getStarted": "Nu aanmelden",
        "downloadCertificate": "Certificaat downloaden",
        "showMore": "Meer weergeven...",
        "bookmark": "Onthouden",
        "unbookmark": "Verwijderen",
        "completeWebinar": "Webinar afronden"
      },
      "sidebar": {
        "content": "Nascholingsinhoud",
        "author": "Auteur",
        "feedback": "Beoordelingen",
        "certificate": "Certificaat",
        "speaker": "Spreker",
        "accessInfo": "Inloggegevens",
        "recording": "Opname",
        "documents": "Documenten",
        "info": "Algemene informatie",
        "navLabel": "Cursusnavigatie"
      },
      "enrollment": {
        "expired": "Je toegang tot deze nascholing is verlopen",
        "expiredAt": "Je toegang tot deze nascholing is verlopen op {date}",
        "accessUntil": "Je hebt tot {date} toegang tot deze nascholing.",
        "freeHint": "Cursus is gratis",
        "closedHint": "Inschrijven niet meer mogelijk",
        "vidisHint": "Met je {vidis}-account kun je deze aanbieding niet direct boeken. Stuur een e-mail naar {emailLink}.",
        "paidHintFlatrate": "Met een {flatrateLink} krijg je vanaf {price} een jaar lang toegang tot alle cursussen.",
        "paidHintCoupon": "Met de code {couponLink} kun je een maand vrijblijvend alle cursussen, AI en tools testen."
      },
      "webinar": {
        "startsAt": "De deelname-informatie voor het webinar wordt kort van tevoren hier weergegeven.",
        "startsAtFuture": "Het webinar vindt plaats op <strong>{date} van {start} tot {end} uur {timezone}</strong>.",
        "startsAtPast": "Het webinar vond plaats op <strong>{date} van {start} tot {end} uur {timezone}</strong>.",
        "startsAtNow": "Het webinar vindt nu plaats van <strong>{start} tot {end} uur {timezone}</strong>.",
        "startsAtToday": "Het webinar vindt vandaag plaats van <strong>{start} tot {end} uur {timezone}</strong>.",
        "startsAtTodayPast": "Het webinar vond vandaag plaats van <strong>{start} tot {end} uur {timezone}</strong>.",
        "recordingHint": "Van deze bijeenkomst komt een opname beschikbaar.",
        "noRecording": "Van deze bijeenkomst komt geen opname beschikbaar."
      },
      "accessInfo": {
        "recordingHintHtml": "Let op: De ondertiteling in onze video's wordt automatisch gegenereerd. Het kan zijn dat niet alle termen correct worden weergegeven. Als je feedback hebt over de ondertiteling, neem dan contact op via <a href=\"mailto:support{'@'}fobizz.com\" target=\"_blank\">support{'@'}fobizz.com</a>",
        "recordingPending": "De opname wordt nog verwerkt. Zodra deze beschikbaar is, wordt deze hier weergegeven.",
        "noRecording": "Voor dit webinar is geen opname beschikbaar."
      },
      "feedback": {
        "emptyHint": "Deze nascholing is nieuw. Er zijn nog geen beoordelingen - maar we kijken uit naar de eerste feedback.",
        "carousel": {
          "previous": "Terug",
          "next": "Verder"
        }
      },
      "feedbackNew": {
        "heading": "Afronding en feedback",
        "complete": "Voltooi alle lessen om feedback te geven. Bedankt!",
        "existing": "Je hebt al feedback gegeven. Hartelijk dank daarvoor!",
        "downloadCertificate": "Certificaat downloaden",
        "form": {
          "rating": "Hoe beoordeel je deze nascholing in het algemeen?",
          "ratingLabels": {
            "1": "Verschrikkelijk",
            "2": "Slecht",
            "3": "Oké",
            "4": "Goed",
            "5": "Zeer goed"
          },
          "recommendationScore": "Hoe waarschijnlijk is het dat je fobizz aanbeveelt?",
          "recommendationLow": "Onwaarschijnlijk",
          "recommendationHigh": "Zeer waarschijnlijk",
          "continueUsing": "Wil je fobizz graag blijven gebruiken?",
          "continueUsingTrue": "Ja",
          "continueUsingFalse": "Nee",
          "publicComment": "Jouw recensie van de cursus",
          "publicCommentHelp": "Maximaal 512 tekens invoeren",
          "authorName": "Naamsvermelding bij de recensie",
          "authorNameHelp": "Bijv. Marie Muster, basisschoolleraar uit NRW",
          "personalComment": "Persoonlijke feedback aan de auteur en het fobizz-team",
          "personalCommentHelp": "Maximaal 512 tekens invoeren",
          "requestedTopics": "Welke onderwerpen wens je nog van fobizz?",
          "requestedTopicsHelp": "Maximaal 512 tekens invoeren",
          "submit": "Verzenden en naar het certificaat",
          "optional": "(optioneel)",
          "requiredHint": "Verplicht veld",
          "errors": {
            "ratingRequired": "Selecteer een beoordeling.",
            "recommendationRequired": "Selecteer een waarde tussen 0 en 10.",
            "continueUsingRequired": "Selecteer een optie.",
            "maxLength": "Maximaal 512 tekens toegestaan."
          }
        }
      },
      "lesson": {
        "headers": {
          "courseContent": "Nascholingsinhoud"
        },
        "links": {
          "completeAndNext": "Klaar en verder",
          "complete": "Klaar",
          "next": "Verder",
          "previous": "Terug",
          "overview": "Naar het cursusoverzicht"
        },
        "labels": {
          "complete": "afgerond"
        },
        "paragraphs": {
          "notEnrolled": "Je bent nog niet ingeschreven voor deze nascholing.",
          "notRegistered": "Meld je aan om je in te schrijven voor deze nascholing."
        },
        "blocks": {
          "download": "Downloaden",
          "noPreview": "Geen voorbeeld beschikbaar",
          "unsupported": "Deze inhoud kan niet worden weergegeven.",
          "videoFallback": "Je browser ondersteunt geen ingebedde video's."
        }
      },
      "recommendations": {
        "empty": "Er zijn momenteel geen aanbevelingen.",
        "error": "Aanbevelingen konden niet worden geladen."
      },
      "status": {
        "headings": {
          "thanks": "Bedankt voor je feedback!",
          "courseIncomplete": "Nascholing niet afgerond",
          "courseIncompleteWebinar": "Webinar niet afgerond",
          "nextSteps": "Hoe nu verder?",
          "noFeedback": "Nog geen feedback gegeven?"
        },
        "paragraphs": {
          "certificate": "Hier vind je na afronding je certificaat.",
          "courseCompleted": "Je hebt deze nascholing afgerond.",
          "courseCompletedWebinar": "Je hebt dit webinar afgerond.",
          "courseIncomplete": "Rond alle lessen van de nascholing af om je certificaat te ontvangen.",
          "courseIncompleteWebinar": "Markeer het webinar als afgerond om je certificaat te ontvangen.",
          "downloadCertificate": "Download nu je certificaat.",
          "materialsHtml": "Neem eens een kijkje bij de <strong>interactieve lesmaterialen</strong> of je iets passends vindt.",
          "certificateNotReady": "Zodra je de nascholing hebt afgerond, vind je hier je certificaat.",
          "certificateNotReadyWebinar": "Zodra je het webinar hebt afgerond, vind je hier je certificaat."
        },
        "links": {
          "downloadCertificate": "Certificaat downloaden",
          "gallery": "Materiaal ontdekken",
          "feedback": "Beoordeel nu de nascholing",
          "feedbackWebinar": "Beoordeel nu het webinar"
        }
      },
      "accordion": {
        "feedbackAndCertificate": "Feedback en certificaat"
      },
      "format": {
        "title": {
          "b2bWorkshop": "Schoolintern & praktijkgericht",
          "b2cWorkshop": "Live & interactief",
          "webinar": "Live & direct",
          "impulse": "Kort & compact",
          "course": "Doorontwikkeling in eigen tempo"
        },
        "content": {
          "b2bWorkshop": "Workshops bieden op maat gemaakte nascholingen direct op jouw school. Samen met het team worden praktijkgerichte onderwerpen uitgewerkt die zijn afgestemd op de specifieke behoeften en uitdagingen van jullie instelling.",
          "b2cWorkshop": "Workshops zijn live webinars met een interactief workshopkarakter. Hier werk je samen met andere docenten aan praktijkgerichte onderwerpen en wissel je ervaringen uit in de groep. Perfect voor iedereen die wil netwerken en van elkaar wil leren.",
          "webinar": "Live webinars bij fobizz maken digitale uitwisseling mogelijk met veelzijdige sprekers uit het onderwijslandschap. Afwisselende presentaties en oefeningen geven nieuwe impulsen, vragen en discussies die verder gaan dan de uitwisseling met collega's in de docentenkamer. Achteraf is er vaak een opname beschikbaar voor degenen die er niet live bij konden zijn.",
          "impulse": "Ontwikkel jezelf verder in slechts 30 minuten. Krijg korte inzichten in nieuwe themawerelden of lesideeën. Zo kun je een kort moment op de dag flexibel en spontaan vullen met een portie praktijkgerichte kennis - en dat in slechts één video! Ter ondersteuning in de praktijk zit er bij elke impuls een oefening en extra materiaal. Na elke impuls ontvang je aanbevelingen om je kennis zelfstandig verder te verdiepen.",
          "course": "Ontvang uitgebreide inzichten over diverse onderwerpen voor de dagelijkse schoolpraktijk. Of het nu gaat om AI, digitale methoden, lesideeën, gezondheid van docenten en nog veel meer! Ontwikkel jezelf en je lessen praktijkgericht en in je eigen tempo. Uit elke online nascholing haal je concrete concepten en kant-en-klare ideeën voor je lessen en dagelijkse werk."
        }
      }
    }
  }
}
